import React from "react";
import "./posts.css";
import Post from "../post/Post";

export default function Posts() {
    return (
        <section className="blog__posts">
            <Post />
            <Post />
            <Post />
            <Post />
            <Post />
            <Post />
            <Post />
            <Post />
            <Post />
        </section>
    );
}
